import mockCandidateData from "../components/Candidate/mockCandidateData";

export default {
	namespaced: true,
	state: {
		candidate: mockCandidateData,
	},
};
